import { CommonModule } from '@angular/common'
import { Component, Input, OnInit, SimpleChanges } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { FlagIcons, Languages } from '../../enums/enums'

@Component({
  selector: 'ddc-country-flag',
  templateUrl: './ddc-country-flag.component.html',
  styleUrl: './ddc-country-flag.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcCountryFlagComponent implements OnInit {
  @Input('ddc_lng') _ddcLng: string
  @Input('has_label') _hasLabel: boolean = false

  _flagIcon: string
  _languageName: string

  constructor(private logger: DdcLoggerService) {}

  ngOnInit(): void {
    this._languageName = this.getLanguageName(this._ddcLng)
    this._flagIcon = this.getFlagIcon(this._languageName)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.logger.info('DdcCountryFlagComponent: ngOnChanges() | changes:', changes)
    if (changes['_ddcLng']) {
      const languageName = this.getLanguageName(changes['_ddcLng'].currentValue)
      this._flagIcon = this.getFlagIcon(languageName)
    }
  }

  getLanguageName(code: string): string | null {
    this.logger.info('DdcCountryFlagComponent: getLanguageName() | code:', code)
    for (const key in Languages) {
      if ((Languages as { [key: string]: readonly string[] })[key][1] === code) {
        return (Languages as { [key: string]: readonly string[] })[key][0]
      }
    }
    return null
  }

  getFlagIcon(languageName: string): string | null {
    this.logger.info('DdcCountryFlagComponent: getFlagIcon() | languageName:', languageName)
    for (const key in FlagIcons) {
      if ((FlagIcons as { [key: string]: readonly string[] })[key][0] === languageName) {
        return (FlagIcons as { [key: string]: readonly string[] })[key][1]
      }
    }
    return null
  }
}
